const riot = require('riot');

riot.tag2('modal-profile', '<div class="modal bg-white w472 s-w-full rounded-8 m8" ref="modal"> <form class="p32" onsubmit="{submit}"> <div class="f fh"> <div class="s80 circle overflow-hidden mb21" ref="icon" data-is="atom-input-image" riot-src="{app.store.currentUser.data.icon_image.url}" icon-size="48"></div> </div> <div class="mb24"> <label> <div class="mb12"> <div class="fs10 lh13 mb6">表示名</div> <input class="input large light_secondary w-full" ref="name" placeholder="{app.data.input.placeholder.display_name}" required> </div> </label> <label> <div class="lh15 mb12"> <div class="f fm lh13 fs10 mb6">ユーザー名</div> <label class="focus-border input large light_secondary f fm"> <div>@</div> <input class="w-full" ref="id" placeholder="{app.data.input.placeholder.id}" minlength="3" maxlength="21" required> </label> <div class="fs10 text-label_dark_medium"> 先頭の「@」を除く、小文字の半角英語文字と数字3文字以上20文字以下、-と_のみ使用可能。</div> </div> </label> </div> <div class="f fh"> <button class="button w220 primary transition">更新 </button> </div> </form> </div>', 'modal-profile,[data-is="modal-profile"]{background-color:rgba(0,0,0,0.5)} modal-profile input::placeholder,[data-is="modal-profile"] input::placeholder{color:rgba(29,40,76,0.2);font-size:13px} modal-profile input:focus,[data-is="modal-profile"] input:focus{outline:none !important}', 'class="f fh s-px8" spat-animation="push"', function(opts) {
    this.on('mount', () => {
      if (spat.isNode) return;

      let user = app.store.currentUser;

      this.refs.name.value = user.data.display_name;
      this.refs.id.value = user.data.screen_name;

      this.update();
    });

    this.submit = async (e) => {
      e.preventDefault();

      let data = {
        display_name: this.refs.name.value.trim(),
        screen_name: this.refs.id.value.trim(),
      };

      let screen_name_validator = app.data.input.validation.screen_name;

      if (!screen_name_validator.test(data.screen_name)) {
        spat.modal.alert('ユーザー名は小文字の英数字、- と _ のみ使用可能で、3～20文字以内で入力してください。');
        return;
      }

      let i = spat.modal.indicator();

      try {
        let url = await this.refs.icon.uploadAndGetImageURL();
        if (url) {
          data.icon_image = {
            url: url,
          };
        }
        await app.api.child('me').put(data);
        spat.modal.alert('更新しました。');
        this.close();
      }
      catch (e) {
        console.error(e);
      }
      finally {
        i.close();
      }
    };
});